import React, {Component} from 'react';
import {Field} from 'redux-form';
import * as Form from './formFieldHelpers';
import * as Date from '../dates/dateHelpers';
import DateField from '../dates/dateField';
import * as Buttons from '../ui/buttons';

export default class PressForm extends Component {
    componentDidMount() {
        this.handleInitialise();
    }

    handleInitialise = () => {
        const { personId, initialize, id, title, publication, url, date, person_id, press } = this.props;

        const month = Date.handleSingleDate(date).month;
        const initialValues = {
            "type": id ? 'UPDATE' : 'CREATE',
            "id": id,
            "person_id": +personId || +person_id || press.personId,
            "title": title,
            "publication": publication,
            "url": url,
            "year": { label: Date.handleSingleDate(date).year, value: Date.handleSingleDate(date).year },
            "month": {label: month && month.name, value: month && month.id},
        };
        initialize(initialValues);
    };

    render() {
        const { date, buttonHandlers, handleCancel, handleAdding } = this.props;

        return (
            <form className="form-standard-profile">
	            <div className="row">
		            <div className="col-xs-12">
			            <Field
				            label="Title"
				            name="title"
				            placeholder="Title"
				            component={ Form.textField }
			            />
		            </div>
		            <div className="col-xs-12 col-md-6">
			            <Field
				            label="Publication"
				            name="publication"
				            placeholder="Publication"
				            component={ Form.textField }
			            />
		            </div>
		            <div className="col-xs-12 col-md-6">
			            <Field
				            label="Url"
				            name="url"
				            placeholder="http://www....."
				            component={ Form.textField }
			            />
		            </div>
		            <div className="col-xs-12">
			            <DateField date={date} />
		            </div>
	            </div>
				<Buttons.HOCFormButtons 
					{ ... buttonHandlers } 
					{ ...this.props } 
					handleCancel={ handleCancel } 
					handleAdding={ form => handleAdding( form ) } />
            </form>
        )
    }
}







// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/forms/PressForm.js